import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Box, List, ListItem, ListItemText } from '@material-ui/core';

import { useStyles, listTextStyles, customCardStyles } from './SkuBehaviour.styled';
import i18n from 'i18n-js';
import { useConfirm } from 'hooks';
import { Card } from 'components/UI';
import { withRouter } from 'react-router-dom';
import { SkusActions } from 'state/modules/skus';
import { SwitchField } from 'components/FormFields';
import Feature from 'components/Feature';

const SkuBehaviour = ({ id }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const listClasses = listTextStyles();
  const cardClasses = customCardStyles();
  const [fields, setFields] = useState({
    auto: false,
    manual: false,
  });
  const [currentAction, setCurrentAction] = useState(null);
  const { sku, fetchingUpdateSku, onboarding } = useSelector((state) => state.skus);
  const editable = !sku?.frozen_time;

  const updateSku = () => {
    const { key, value } = currentAction;
    setFields({
      ...fields,
      [key]: value,
    });
    dispatch(SkusActions.fetchUpdateSku(id, { [key]: value }));
  };

  const [toggleUpdateSku, UpdateSkuConfirm] = useConfirm({
    title: i18n.t('skus.change_settings'),
    message: i18n.t(
      `${
        currentAction?.name === 'manual'
          ? 'skus.change_settings_manual'
          : 'skus.change_settings_automated'
      }`
    ),
    cancelText: i18n.t('common.cancel'),
    confirmText: i18n.t('common.change'),
    onConfirm: updateSku,
  });

  useEffect(() => {
    if (sku && sku.id) {
      setFields({
        auto: sku.auto,
        manual: sku.manual,
      });
    }
  }, [sku]); // eslint-disable-line

  useEffect(() => {
    if (id) {
      dispatch(SkusActions.fetchSkuById(id));
    }
  }, [id]); // eslint-disable-line

  useEffect(() => {
    if (Object.keys(onboarding.errors).length && currentAction) {
      const { key, value } = currentAction;
      setFields({
        ...fields,
        [key]: !value,
      });
      setCurrentAction(null);
    }
  }, [onboarding.errors]); // eslint-disable-line

  const handleChangeStatus = (name, value) => {
    editable && setCurrentAction({ key: name, value });
    editable && toggleUpdateSku();
  };

  return (
    <Card title={i18n.t('skus.behaviour')} contentRootClasses={cardClasses}>
      <Box className={classes.cardContentPadding}>
        <List className={classes.skuList}>
          <Feature name="pricing" is="pricing_rules_set">
            <ListItem className={classes.skuListItem}>
              <ListItemText
                classes={{
                  root: listClasses.root,
                  primary: listClasses.primary,
                  secondary: listClasses.secondary,
                }}
                disabled={fetchingUpdateSku}
                primary={i18n.t('skus.automated_sku')}
                secondary={
                  <Box
                    display="flex"
                    component="span"
                    flexDirection="column"
                    className={classes.textRight}
                  >
                    <SwitchField
                      name="auto"
                      form={{
                        setFieldValue: handleChangeStatus,
                      }}
                      inline={true}
                      color="primary"
                      validateChecked={true}
                      field={{
                        name: 'auto',
                        value: fields?.auto || false,
                      }}
                      component={SwitchField}
                      disabled={!editable}
                    />
                  </Box>
                }
              />
            </ListItem>
          </Feature>
          <ListItem className={classes.skuListItem}>
            <ListItemText
              classes={{
                root: listClasses.root,
                primary: listClasses.primary,
                secondary: listClasses.secondary,
              }}
              primary={i18n.t('skus.manual_sku')}
              secondary={
                <Feature name="pricing" is="pricing_rules_set">
                  <SwitchField
                    name="manual"
                    inline={true}
                    form={{
                      setFieldValue: handleChangeStatus,
                    }}
                    validateChecked={true}
                    color="primary"
                    field={{
                      name: 'manual',
                      value: fields?.manual || false,
                    }}
                    component={SwitchField}
                    disabled={!editable}
                  />
                </Feature>
              }
            />
          </ListItem>
        </List>
        <UpdateSkuConfirm />
      </Box>
    </Card>
  );
};

export default withRouter(SkuBehaviour);
